import React from 'react';

function NotFound() {
  return (
    <div className="notFound">
      <h1>Uh Oh!</h1>
      <p>The page you are looking for does not exist.</p>
    </div>
  );
}

export default NotFound;